import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';


import { SettingsRulesEditorService } from '@app/services/settings/srules.service';
import * as fromRulesModel from '@app/models/rules';

import * as Search from '@app/models/search';

@Component({
  selector: 'settings-rules-rule-conditions-item',
  templateUrl: './condition-item.component.html',
  styleUrls: ['./condition-item.component.scss'],
})
export class SettingsRulesRuleFormConditionsItemComponent implements OnInit, OnChanges{

    // IMPORTANT: those are the keys for what we have to show condition searchable selector
    public readonly CONDITION_LABELS_SEARCHABLE_KEYS = ['request_labels','version_labels'];

    @Input() conditionForm: fromRulesModel.AvailableRuleItemForm; //RuleCondition;
    @Input() availableConditions: Array<fromRulesModel.AvailableRuleEventCondition>;
    @Input() ruleConditions: Array<fromRulesModel.RuleCondition>;

    @Output() clickAdd = new EventEmitter();
    @Output() clickRemove = new EventEmitter<string>(); 
    @Output() changeRuleCondition = new EventEmitter<fromRulesModel.RuleCondition>(); //RuleCondition;

    public currentCondition: fromRulesModel.AvailableRuleEventCondition = null;
    public currentRuleCondition: fromRulesModel.RuleCondition = null;
    public term: string = '';
    public found: Array<fromRulesModel.AvailableRuleConditionValueItem> = [];

    constructor( protected editorSrv: SettingsRulesEditorService){}

    ngOnInit(): void {
        if(this.conditionForm != null && this.availableConditions != null){ 
            this.currentCondition = this.getAvailableCondition(this.conditionForm.key);
            this.currentRuleCondition = this.getRuleCondition(this.conditionForm.id);
            this.term = this.conditionForm.search.term;
            this.found = this.conditionForm.search.found;
        }
    }

    // We need to keep tracking op conditions loading to display on form
    ngOnChanges(changes: SimpleChanges): void {
        if(changes.availableConditions){
            this.currentCondition = this.getAvailableCondition(this.conditionForm.key);
        }
    }

    // term for search change
    onSetTerm(term: string) : void {
        this.term = term;
        //  set term on this form in the store to set found values
        this.editorSrv.setRuleConditionsFormTerm(this.conditionForm, term);
    }

    onSelection(items: Array< fromRulesModel.AvailableRuleItem>) {

    }

    onRemove(filter: Search.SearchAppliedFilter){
        // console.log(" %%%%%% remove filter... ",filter);
    }

    // update variable means update also condition and value selected
    selectVariable(event){
        console.debug("select condition variable---->e",event, this.conditionForm);

        let condition  = {
            ...this.currentRuleCondition,
            variable: event.key
        };

        this.changeRuleCondition.emit(condition);
    }

    selectOption(event){
        // console.debug("select condition option--->",event);

        let condition = {
            ...this.currentRuleCondition,
            condition: event.key
        };

        this.changeRuleCondition.emit(condition);
    }

    // this will be a single element array for conditions.
    onSelectValue(selected: Array< fromRulesModel.AvailableRuleItem>){
        
        // CAREFUL SETTING empty values on the rule when we remove the value.
        let condition = {
            ...this.currentRuleCondition,
            value: selected.length > 0 ? selected[0].key : ''
        };

        this.changeRuleCondition.emit(condition);
    }

    addCondition(){
        this.clickAdd.emit();
    }

    removeCondition(){
        this.clickRemove.emit(this.conditionForm.id);
    }

    // filter the available conditions for the current rule by given form key
    getAvailableCondition(key: string) : fromRulesModel.AvailableRuleEventCondition {
        let cs = this.availableConditions.filter((ac:fromRulesModel.AvailableRuleEventCondition) => ac.key == key );
        
        return cs[0];
    }

    // filter the condition for the current rule by given form id
    getRuleCondition(id: string) : fromRulesModel.RuleCondition {
        let cc = this.ruleConditions.filter((ac:fromRulesModel.RuleCondition) => ac.form_id == id );
        return cc[0];
    }
}
